import { message, Modal } from 'ant-design-vue'
import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router'
import { useUserStoreOutside } from '@/store/modules/user'
import { NO_ROLE_CODE } from '@/api/http/constant'
import { AUTH_ROUTES_NAME, LOGIN_ROUTE_NAME, WHITE_ROUTES_NAME } from '../constant'

/**
 * 处理用户登出逻辑
 */
const handleLogout = (to: RouteLocationNormalized, next: NavigationGuardNext) => {
  const userStore = useUserStoreOutside()
  userStore.logout()
  const redirect = to.fullPath
  next({ name: LOGIN_ROUTE_NAME, replace: true, query: { redirect } })
}

export const createAuthGuard = (router: Router) => {
  const userStore = useUserStoreOutside()

  router.beforeEach(async (to, _from, next) => {
    const toName = to.name as string
    const isLogin = userStore.isLogin

    // ========================================
    // 1. 未登录用户的处理
    // ========================================
    if (!isLogin) {
      if (WHITE_ROUTES_NAME.includes(toName)) {
        next()
        return
      }
      handleLogout(to, next)
      return
    }

    // ========================================
    // 2. 已登录用户访问认证页面的处理
    // ========================================
    if (AUTH_ROUTES_NAME.includes(toName)) {
      next({ path: '/', replace: true })
      return
    }

    // ========================================
    // 3. 用户信息加载处理
    // ========================================
    if (!userStore.isLoadInfo) {
      try {
        // 加载用户信息
        await userStore.afterLogin()

        // 用户信息加载成功后，重新导航到目标路由（避免白屏）
        next({ ...to, replace: true })
      } catch (err) {
        const _err = err as any
        console.error('加载用户信息失败:', err)
        if (_err?.code === NO_ROLE_CODE) {
          next(false)
          Modal.error({
            title: '重要提示',
            content: '您的账号暂无权限访问该系统，请联系管理员开通权限！',
            centered: true,
            onOk() {
              userStore.logout()
              router.replace({ name: LOGIN_ROUTE_NAME })
            }
          })
          return
        }
        message.error('获取用户信息失败，请重新登录')
        handleLogout(to, next)
      }
      return
    }

    next()
  })
}
